import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const GenericHeroHeader = ({ className = '', subtitle, ...props }) => (
  <div className={`${styles.GenericHeroHeader} ${className}`}>
    {props.icon && (
      <img className={styles.GenericHeroHeader_icon} src={props.icon} alt="" />
    )}

    <h1 className={`${styles.GenericHeroHeader_title} title`}>{props.title}</h1>

    {subtitle && (
      <h5 className="mt-3 text-center font-weight-bold">{subtitle}</h5>
    )}
  </div>
);

GenericHeroHeader.propTypes = {
  className: PropTypes.string,
  subtitle: PropTypes.string,
};

export default GenericHeroHeader;
